module.exports = __webpack_public_path__ + "static/dwiLandingHeader-45c9aba85ac65facd6adc706cc3f0229.jpg";